export const isRenderablePdf = blob => !!blob && !!blob.size;
